// Slice de UI da feature goals (Metas): mês selecionado + loja selecionada.
// A meta é sempre mensal, então o filtro global da tela é um MÊS ("YYYY-MM"),
// diferente do resto do app (que usa presets de dia). Default = mês atual.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Mês corrente no formato "YYYY-MM" (calendário local). */
export function currentMonth(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

export interface GoalsUiState {
  /** "YYYY-MM". */
  selectedMonth: string;
  /** Id da loja em foco nas abas por-loja. `null` = ainda não resolvida. */
  selectedStoreId: string | null;
}

const initialState: GoalsUiState = {
  selectedMonth: currentMonth(),
  selectedStoreId: null,
};

const slice = createSlice({
  name: 'goalsUi',
  initialState,
  reducers: {
    goalsMonthChanged(state, action: PayloadAction<string>) {
      state.selectedMonth = action.payload;
    },
    goalsStoreChanged(state, action: PayloadAction<string>) {
      state.selectedStoreId = action.payload;
    },
  },
});

export const { goalsMonthChanged, goalsStoreChanged } = slice.actions;
export const goalsUiReducer = slice.reducer;

export const selectGoalsMonth = (s: { goalsUi: GoalsUiState }): string => s.goalsUi.selectedMonth;
export const selectGoalsStore = (s: { goalsUi: GoalsUiState }): string | null =>
  s.goalsUi.selectedStoreId;
